<template>
  <div>
    <div>
      <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleCreate()">添加</el-button>
      <el-button type="primary" icon="el-icon-download" size="mini" @click="exportJl()">导出</el-button>

      <el-input
        v-model="listQueryJL.name"
        clearable
        placeholder="请输入名称"
        style="width:200px;margin-left:16px"
        size="mini"
      ></el-input>

      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left:16px"
        size="mini"
        @click="getJLList()"
      >搜索</el-button>

      <el-button type="primary" size="mini" @click="handleJLUpdate()">编辑</el-button>

      <el-button
        type="danger"
        style="margin-left:16px"
        size="mini"
        @click="handleDelete()"
        icon="el-icon-delete"
      >删除</el-button>
    </div>

    <div style="margin-top:20px">
      <el-table
        ref="JLTable"
        :key="tableKey"
        :data="JLlist"
        height="530px"
        border
        style="width:100%"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" :selectable="checkboxSelect" width="40"></el-table-column>
        <el-table-column min-width="110px" align="center" :label="'培训班名称'" show-overflow-tooltip prop="name"></el-table-column>
        <el-table-column
          min-width="90px"
          :label="'培训类别'"
          :show-overflow-tooltip="true"
          align="center"
          prop="catename"
        ></el-table-column>

        <el-table-column width="180px" :label="'证书编号'" align="center" prop="code"></el-table-column>

        <el-table-column min-width="90px" align="center" :label="'主办单位'" prop="unit" show-overflow-tooltip></el-table-column>

        <el-table-column width="100px" :label="'发布时间'" align="center" prop="publishtime">
          <template slot-scope="scope">
            <span>{{scope.row.publishtime.substring(0,10)}}</span>
          </template>
        </el-table-column>

        <el-table-column
          width="60px"
          min-height="140px"
          :label="'来源'"
          align="center"
          prop="comefrom"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.comefrom==0">
              <span>系统</span>
            </span>
            <span v-else-if="scope.row.comefrom==1">
              <span>用户</span>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQueryJL.page"
        :limit.sync="listQueryJL.limit"
        @pagination="handleCurrentChange"
      />
    </div>

    <el-dialog
      :fullscreen="false"
      class="dialog-mini"
      width="30%"
      title="添加"
      :visible.sync="dialogFormJL"
      destroy-on-close
    >
      <el-form :model="JLform" :rules="JLrules" ref="JLform" label-width="100px">
        <el-form-item size="small" :label="'培训班名称'" prop="name">
          <el-input v-model="JLform.name"></el-input>
        </el-form-item>

        <el-form-item size="small" :label="'主办单位'" prop="unit">
          <el-input v-model="JLform.unit"></el-input>
        </el-form-item>
        <el-form-item size="small" :label="'证书编号'" prop="code">
          <el-input v-model="JLform.code" type="text"></el-input>
        </el-form-item>
        <el-form-item label="培训班类型" prop="cateDicId">
          <elSelectc
            v-if="dialogFormJL"
            :NamespaceId="53"
            :key="sid"
            :typeids="JLform.cateDicId"
            @selectData="selectDatajzDicId"
          ></elSelectc>
        </el-form-item>
        <el-form-item size="small" :label="'发布日期'" prop="publishTime">
          <el-date-picker
            v-model="JLform.publishTime"
            type="date"
            placeholder="发布日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="文件">
          <div style="display: flex;">
            <el-upload
              v-if="dialogFormJL"
              ref="myupload"
              :headers="headers"
              action="/resource/File/UploadFile"
              :on-remove="activityFileHandleRemove"
              :on-success="activitysuccess"
              multiple
              v-model="JLform.fileUrl"
              accept="application/pdf"
              :limit="1"
              :show-file-list="false"
            >
              <el-button type="primary" size="mini">上传</el-button>
            </el-upload>
            <el-button
              v-if="JLform.fileUrl"
              style="margin-left: 10px;"
              @click="activityFileHandleLook"
              size="mini"
            >查看</el-button>
            <el-button size="mini" v-if="JLform.fileUrl" @click="activityFileHandleRemove">移除</el-button>
          </div>
        </el-form-item>

        <div style="text-align:center">
          <el-button size="mini" type="primary" @click="JLsubmit()">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template> 
<script>
import * as PersonCenter from '@/api/personcenter/index';
import Pagination from '@/components/Pagination';
import elDragDialog from '@/directive/el-dragDialog';
import elSelectc from '@/components/elSelect';
import { getInfo} from '@/utils/auth';
export default {
  components: {
    Pagination,
    elSelectc,
  },
  directives: {
    elDragDialog,
  },
  props: {
    teachername: String,
    userId: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      sid: +new Date(),
      multipleSelection: [],
      topicId: 0,
      dialogFormJL: false,
      tableKey: 0,
      total: 0,
      JLlist: [],
      JLform: {
        id: 0,
        cateDicId: 0,
        userId: this.userId,
        name: '',
        code: '',
        unit: '',
        publishTime: '',
        fileUrl: '',
        passStatus: 0,
      },
      JLrules: {
        name: [{ required: true, message: '班级不能为空', trigger: 'blur' }],
        cateDicId: [
          { required: true, message: '类别不能为空', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '证书编号不能为空', trigger: 'blur' },
        ],
        unit: [
          { required: true, message: '主办单位不能为空', trigger: 'blur' },
        ],
        publishTime: [
          { required: true, message: '发布时间不能为空', trigger: 'blur' },
        ],
      },
      listQueryJL: {
        page: 1,
        limit: 10,
        userId: this.userId,
        name: '',
      },
      socreName: '',
    };
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
    getinfo() {
      return this.$store.state.User.infos;
    },     
  },
  created() {
    let list = JSON.parse(getInfo('infos'));
    this.socreName=list.name
    this.getJLList();
  },
  methods: {
    selectDatajzDicId(val) {
      this.JLform.cateDicId = val.value;
    },
    activityFileHandleRemove(file, fileList) {
      this.JLform.fileUrl = '';
      this.$nextTick(() => {
        this.$refs.myupload.clearFiles();
      });
    },
    activitysuccess(response, file, fileList) {
      this.JLform.fileUrl = response.result;
      this.$message.success('上传成功！');
    },
    activityFileHandleLook() {
      if (this.JLform.fileUrl == '') {
        this.$notify({
          title: '失败',
          message: '没有文件可查看',
          type: 'warning',
        });
      } else {
        //下载文件
        window.open(this.JLform.fileUrl);
      }
    },

    checkboxSelect(row, rowIndex) {
      if (row.comefrom == 0) {
        return false; // 禁用
      } else {
        return true; // 不禁用
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleCreate() {
      this.JLform = {
        id: 0,
        cateDicId: 0,
        userId: this.userId,
        name: '',
        code: '',
        unit: '',
        publishTime: '',
        fileUrl: '',
        passStatus: 0,
      };
      this.dialogFormJL = true;
    },
    JLsubmit() {
      this.$refs['JLform'].validate((vaild) => {
        if (vaild) {
          if (this.JLform.id == 0) {
            PersonCenter.TeacherCerAdd(this.JLform).then((res) => {
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000,
              });
              this.dialogFormJL = false;
              this.getJLList();
            });
          } else {
            this.JLform.updateId = JSON.parse(getInfo('infos')).id;
            PersonCenter.TeacherCerUpdate(this.JLform).then((res) => {
              this.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
                duration: 2000,
              });
              this.dialogFormJL = false;
              this.getJLList();
            });
          }
        }
      });
    },

    exportJl() {
      let that = this;
      let data = {
        page: 1,
        limit: 1000,
        userId: this.userId,
        State: 0,
      };
      PersonCenter.CenterMyCerInfoList(data).then((res) => {
        res.data.forEach((element, index) => {
          res.data[index].publishtime = element.publishtime.slice(0, 10);
        });
        let list = res.data;
        require.ensure([], () => {
          const { export_json_to_excel } = require('@/excel/export2Excel'); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
          const tHeader = [
            '培训班名称',
            '培训类别',
            '证书编号',
            '主办单位',
            '发布时间',
            '数据来源',
          ]; // 导出的表头名信息
          const filterVal = [
            'name',
            'catename',
            'code',
            'unit',
            'publishtime',
            'comefrom',
            ,
          ]; // 导出的表头字段名，需要导出表格字段名

          list.forEach((e) => {
            if (e.comefrom === 0) {
              e.comefrom = '系统';
            } else {
              e.comefrom = '用户';
            }
          });

          const data = that.formatJson(filterVal, list);

          export_json_to_excel(tHeader, data, this.socreName + '证书excel'); // 导出的表格名称，根据需要自己命名
        });
      });
    },
    //格式转换，直接复制即可
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    getJLList() {
      this.listQueryJL.userId = this.userId;
      PersonCenter.CenterMyCerInfoList(this.listQueryJL).then((res) => {
        this.JLlist = res.data;
        this.total = res.count;
      });
    },
    handleJLUpdate() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '警告',
          message: '请选择一条进行编辑',
          type: 'warning',
          duration: 2000,
        });
        return false;
      }
      if (this.multipleSelection.length > 1) {
        this.$notify({
          title: '警告',
          message: '只能选择一条进行编辑',
          type: 'warning',
          duration: 2000,
        });
        return false;
      }

      PersonCenter.TeacherCerGet({ id: this.multipleSelection[0].id }).then(
        (res) => {
          this.JLform = Object.assign({}, res.result);
          this.dialogFormJL = true;
        }
      );
    },
    handleDelete(row) {
      // 多行删除
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '警告',
          message: '请选择一条进行删除',
          type: 'warning',
          duration: 2000,
        });
      } else {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          PersonCenter.TeacherCerDelete(
            this.multipleSelection.map((u) => u.id)
          ).then(() => {
            this.total = this.total - this.multipleSelection.length;
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000,
            });
            this.getJLList();
          });
        });
      }
    },
    handleCurrentChange(val) {
      this.listQueryJL.page = val.page;
      this.listQueryJL.limit = val.limit;
      this.getJLList();
    },
  },
};
</script>